// extracted by mini-css-extract-plugin
export default {"wrapper_article":"Article_wrapper_article__2thVT","reply":"Article_reply__vfKfe","new":"Article_new__oe7ID"};